"use strict";

import { CartaoForm, Icartao } from './cartaoUtils';
import { UtenteForm, Iutente } from './utentesUtils';
import { errorFuncStruct, conection } from './conectionUtils';

export interface ConsultaFormData {
  id: number | null;
  tratamentos: number | null;
  data: string;
  hora: string | null;
  flag_doc: 1 | 0;
  flag_recepcao: 1 | 0;
  flag_alta: 1 | 0;
}

export interface Seguro {
  id: number;
  nome: string;
  n_tratamentos: number | null;
}

export interface ConsultaHelper {
  seguros: Seguro[] | null;
  consulta: Iconsulta | null;
  cartao: Icartao | null;
  utente: Iutente | null;
  terapeuta: string | null;
  sessions: {total: number; actual: number} | undefined;
  sessions_act: {total: number; actual: number} | undefined;
}

export function getConsultaHelpers(
  idConsulta: number | null,
  idUtente: number | null,
  idCartao: number | null,
  cbOk: (rBody: ConsultaHelper) => void,
  cbError: errorFuncStruct
): void {
  conection(
    "getConsultaHelpers.php",
    {idConsulta: idConsulta, idUtente: idUtente, idCartao: idCartao},
    (rBody) => { 
      const returnHelpers: ConsultaHelper = {
        seguros: rBody.seguros,
        consulta: rBody.consulta,
        cartao: rBody.cartao,
        utente: rBody.utente,
        terapeuta: rBody.terapeuta,
        sessions: rBody.sessions,
        sessions_act: rBody.sessions_act,
      }
      cbOk(returnHelpers);
    },
    cbError
  );
}

export function consultaServer(
  consulta: ConsultaFormData,
  cartao: CartaoForm | null,
  utente: UtenteForm | null,
  cbOk: () => void,
  cbError: errorFuncStruct
) {
  conection(
    "processConsulta.php",
    {consulta: consulta, cartao: cartao, utente: utente},
    cbOk,
    cbError
  );
}

export interface Iconsulta{
  id: number;
  id_cartao: number;
  n_tratamentos: number;
  data: string;
  hora: string | null;
  flag_doc: 1 | 0;
  flag_recepcao: 1 | 0;
  flag_alta: 1 | 0;
  timestamp: string;
}
export class Consulta{
  private consultaBD: Iconsulta;
  constructor(consulta: Iconsulta){
    this.consultaBD = consulta;
  }

  public get consultaForm(): ConsultaFormData{
    const consulta: ConsultaFormData = {
      id: this.consultaBD.id,
      tratamentos: this.consultaBD.n_tratamentos,
      data: this.consultaBD.data,
      hora: this.consultaBD.hora,
      flag_doc: this.consultaBD.flag_doc,
      flag_recepcao: this.consultaBD.flag_recepcao,
      flag_alta: this.consultaBD.flag_alta,
    }
    return consulta;
  }

  public get id(): number{
    return this.consultaBD.id;
  }
}

export interface Tratamentos{
  tratamento: string;
  tratamento_aux: string;
}
export function checkTratamentoAux(tratamento: string, separators: string[]): Tratamentos{
  // console.log("🚀 ~ file: consultaUtils.ts ~ line 114 ~ checkTratamentoAux ~ separators", separators)
  // console.log("🚀 ~ file: consultaUtils.ts ~ line 114 ~ checkTratamentoAux ~ tratamento", tratamento)
  const returnArray: Tratamentos = {
    tratamento: '',
    tratamento_aux: ''
  }
  for (let index = 0; index < separators.length; index++) {
    const separator = separators[index];

    if(tratamento.indexOf(separator) !== -1){
      const tratamento_array = tratamento.split(separator);
      if(tratamento_array[0]){
        returnArray.tratamento = tratamento_array[0];
      }
      if(tratamento_array[1]){
        returnArray.tratamento_aux = tratamento_array[1];
      }

      index = separators.length;
    }
  }

  if(!returnArray.tratamento) returnArray.tratamento = tratamento;

  return returnArray;
}